var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-bar text-center"},[_c('b-form-input',{attrs:{"placeholder":"Search for a movie/actor/producer"},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }